import { request } from 'src/helpers/api';
import type { AxiosResponse } from 'axios';

type ApiResponse = Promise<AxiosResponse>;

export const getJobs = (status: string, params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/jobs/${status}`,
    params,
    cancel_token: 'getJobList',
  })
);

export const getOpenJobs = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/job-progress-board/open-jobs',
    params,
    cancel_token: 'getJobList',
  })
);
export const getOpenJobsFilter = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/job-progress-board/open-jobs/filters',
    params,
    cancel_token: 'getOpenJobsFilter',
  })
);

export const getJobDetails = (jobId: string | number): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/job/${jobId}`,
  })
);

export const getClosedJobs = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/jobs/service-request/closed',
    params,
    cancel_token: 'getJobList',
  })
);

export const getAllJobs = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/jobs/service-request/all-jobs',
    params,
    cancel_token: 'getAllJobList',
  })
);

export const getSpecificJobDetails = (jobId: string | number, requestType: string): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/job/${jobId}/${requestType}`,
  })
);
export const getInvoiceDescription = (invoiceId: string | number): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/invoices/${invoiceId}/description`,
  })
);

export const getExportJobs = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/jobs/service-request/all-jobs/generate-export-link',
    params,
  })
);

export const getExportMedia = (
  jobId: string | number,
  source: string,
  params: Record<string, unknown> = {},
): ApiResponse => (
  request({
    method: 'POST',
    url: `/api/job/${jobId}/media/${source}/download`,
    params,
  })
);

export const sendAskQuestion = (
  jobId: string | number,
  params: Record<string, unknown>,
): ApiResponse => (
  request({
    method: 'POST',
    url: `/api/jobs/${jobId}/ask-a-question`,
    params,
  })
);

export const getReview = (rootJobId: string | number): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/service-request/job/${rootJobId}/tenant_review`,
  })
);

export const getClosedMakeReadyJobs = (params: Record<string, unknown> = {}): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/jobs/make-readies/closed',
    params,
    cancel_token: 'getClosedMakeReadyJobsList',
  })
);

export const getClosedMakeReadyJobDetails = (
  jobId: string | number,
  params: Record<string, unknown> = {},
): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/job/make-ready/${jobId}`,
    params,
  })
);

export const getOpenMakeReadyFilters = (): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/jobs/make-readies/open/filters',
  })
);

export const getCustomerNotes = (
  jobId: string | number,
  params: Record<string, unknown> = {},
): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/job/${jobId}/customer_notes`,
    params,
  })
);

export const getEscalationDetails = (
  escalationId: string,
  type: 'escalation' | 'de-escalation' = 'escalation',
): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/property-escalation/${escalationId}`,
    params: { type },
  })
);

export const getInvoiceDetails = (invoiceId: string | number): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/invoices/${invoiceId}/invoice-details`,
  })
);
